export const isSmartIdPlusAuthenticationEnabled = () => window.config.SMART_ID_PLUS_AUTHENTICATION_ENABLED === 'true';
